var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapsedLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3016_50725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5597 20.2391H13.8672V29.8045L27.5934 16.0609C23.0563 15.4949 18.9504 15.2502 15.3236 15.207L16.5597 20.2343V20.2391Z",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.132812 13.7532C2.86847 14.2473 7.04621 14.7893 12.4936 14.8853L12.5606 14.6166C11.7366 14.1561 11.1761 13.2735 11.1761 12.2613C11.1761 10.7742 12.3834 9.56534 13.8686 9.56534V0",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8677 29.8096V20.2443H11.1751L12.4112 15.2266C7.16988 15.3225 3.11191 15.8358 0.390625 16.3155L9.22522 19.5631L13.8725 29.8144L13.8677 29.8096Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5597 12.2661C16.5597 13.2783 16.004 14.1609 15.1751 14.6214L15.2422 14.8997C18.96 14.8613 23.1809 14.607 27.8569 14.0122L18.5097 10.2513L13.8672 0V9.57013C15.3524 9.57013 16.5597 10.779 16.5597 12.2661Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8617 14.0122L13.8672 0L18.5145 10.2513L27.8617 14.0122Z",
    fill: "url(#paint0_linear_3016_50725)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8617 14.0122L13.8672 0L18.5145 10.2513L27.8617 14.0122Z",
    fill: "#E2833D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22522 19.5582L0.390625 16.3105L13.8725 29.8095L9.22522 19.5582Z",
    fill: "url(#paint1_linear_3016_50725)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22522 19.5582L0.390625 16.3105L13.8725 29.8095L9.22522 19.5582Z",
    fill: "#E2833D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3016_50725",
    x1: 18.8738,
    y1: 15.341,
    x2: 20.9484,
    y2: 6.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3016_50725",
    x1: 10.95,
    y1: 16.0803,
    x2: 7.04251,
    y2: 23.2046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3016_50725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.7289,
    height: 29.8144,
    fill: "white",
    transform: "translate(0.132812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsedLogo);
export default __webpack_public_path__ + "static/media/collapsedLogo.9f5da2c197b3b9d62ce15b67de9f0062.svg";
export { ForwardRef as ReactComponent };